<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import {
  required,
  decimal,
} from 'vuelidate/lib/validators'
import Vue from 'vue'
import Swal from 'sweetalert2'

import * as axios from 'axios'

    const PUBLISHERS_API_URL = process.env.VUE_APP_API_URL + 'publishers/';
    const SLIDES_API_URL = process.env.VUE_APP_API_URL + 'slides/';
    const PREBID_GROUPS_API_URL = process.env.VUE_APP_API_URL + 'prebid-groups/';
    const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';
    const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites/';
    const CACHE_API_URL = process.env.VUE_APP_API_URL + 'cache/config/site/';
    const PREBID_ADUNITS_API_URL = process.env.VUE_APP_API_URL + 'prebid-adunits/';
    const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';
    const CHECK_LINES_URL = process.env.VUE_APP_API_URL + 'sites/[id]/missing-lines';


/**
 * Create publisher form component
 */
export default {
  page: {
    title: 'Site Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    VueNestable,
    VueNestableHandle
  },
  data() {
    return {
      title: 'Site Form',
      items: [
        {
          text: 'Unblockia',
          href: '/',
        },
        {
          text: 'Sites',
          href: '/admin/sites',
        },

        {
          text: '',
          active: true,
        },
      ],
        savingSlides: false,
        creatingNewSlide: false,
        prebidGroups: [],
        slides: [],
        defaultSlides: [],
        defaultSlidesNameList: [
            "First slide (Cr, App, Adf, Rub, Smart) ",
            "Default 1",
            "Default 2",
            "Default 1",
            "Default 2",
            "Default 1",
            "Default 2",
            "Default 1",
            "Default 2",
        ],
        site: {
            domain: '',
            publishers: [],
            mediaBuyer: '',
            category: '',
            country: '',
            isActive: false,
            impressionMultiplier: 1,
            impressionMultiplierLastUpdate: null,
            cpmFloor: null,
            hash: '',
            mytargetId: '',
            config: {
                unblockiaBanner: 1,
                adponeBanner: 3,
                showStickyAt: 0
            }

        },
        prebidAdunits: {
            'adform banner': {
                provider: 'adform',
                mediaType: 'banner',
                fields: ['mid'],
                items: {
                    '300x600': { mid: ''},
                    '300x250': { mid: ''},
                    '728x90': { mid: ''},
                    '160x600': { mid: ''},
                    '320x50': { mid: ''},
                    '120x600': { mid: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/adform.png')
            },

            /* 'adform native': {
                provider: 'adform',
                mediaType: 'native',
                fields: ['mid'],
                items: {
                    '300x600': { mid: ''},
                    '300x250': { mid: ''},
                    '728x90': { mid: ''},
                    '160x600': { mid: ''},
                    '320x50': { mid: ''},
                    '120x600': { mid: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/adform.png')
            }, */

            /* 'adtrue banner': {
                provider: 'adtrue',
                mediaType: 'banner',
                fields: ['zoneId', 'publisherId'],
                items: {
                    '300x600': { zoneId: '', publisherId: ''},
                    '300x250': { zoneId: '', publisherId: ''},
                    '728x90': { zoneId: '', publisherId: ''},
                    '160x600': { zoneId: '', publisherId: ''},
                    '320x50': { zoneId: '', publisherId: ''},
                    '120x600': { zoneId: '', publisherId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/adtrue.png')
            }, */

            'appnexus native': {
                provider: 'appnexus',
                tagName: 'xandr',
                mediaType: 'native',
                providerSubtitle: 'native and banner',
                fields: ['placementId'],
                items: {
                    '300x600': { placementId: ''},
                    '300x250': { placementId: ''},
                    '728x90': { placementId: ''},
                    '160x600': { placementId: ''},
                    '320x50': { placementId: ''},
                    '120x600': { placementId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/appnexus.png')
            },

            /* 'appnexus banner static': {
                provider: 'appnexus',
                mediaType: 'banner static',
                fields: ['placementId'],
                items: {
                    '300x600': { placementId: ''},
                    '300x250': { placementId: ''},
                    '728x90': { placementId: ''},
                    '160x600': { placementId: ''},
                    '320x50': { placementId: ''},
                    '120x600': { placementId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/appnexus.png')
            }, */

            /* 'between banner static': {
                provider: 'between',
                mediaType: 'banner static',
                fields: ['s'],
                items: {
                    '300x600': { s: ''},
                    '300x250': { s: ''},
                    '728x90': { s: ''},
                    '160x600': { s: ''},
                    '320x50': { s: ''},
                    '120x600': { s: ''},
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/between.png')
            }, */

            /* 'between banner': {
                provider: 'between',
                mediaType: 'banner',
                fields: ['s'],
                items: {
                    '300x600': { s: ''},
                    '300x250': { s: ''},
                    '728x90': { s: ''},
                    '160x600': { s: ''},
                    '320x50': { s: ''},
                    '120x600': { s: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/between.png')
            }, */

            /* 'bidscube banner': {
                provider: 'bidscube',
                mediaType: 'banner',
                fields: ['placementId'],
                items: {
                    '300x600': { placementId: ''},
                    '300x250': { placementId: ''},
                    '728x90': { placementId: ''},
                    '160x600': { placementId: ''},
                    '320x50': { placementId: ''},
                    '120x600': { placementId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/bidscube.png')
            }, */

            'criteo banner static': {
                provider: 'criteo',
                mediaType: 'banner static',
                fields: ['zoneId'],
                items: {
                    '300x600': {
                        zoneId: ''
                    },
                    '300x250': {
                        zoneId: ''
                    },
                    '728x90': {
                        zoneId: ''
                    },
                    '160x600': {
                        zoneId: ''
                    },
                    '320x50': {
                        zoneId: ''
                    },
                    '120x600': {
                        zoneId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/criteo.png')
            },

            /* 'mytarget banner static': {
                provider: 'mytarget',
                mediaType: 'banner static',
                fields: ['placementId'],
                items: {
                    '300x600': { placementId: ''},
                    '300x250': { placementId: ''},
                    '728x90': { placementId: ''},
                    '160x600': { placementId: ''},
                    '320x50': { placementId: ''},
                    '120x600': { placementId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/mytarget.png')
            }, */

            'onetag banner': {
                provider: 'onetag',
                mediaType: 'banner',
                fields: ['pubId'],
                items: {
                    '300x600': {
                        pubId: ''
                    },
                    '300x250': {
                        pubId: ''
                    },
                    '728x90': {
                        pubId: ''
                    },
                    '160x600': {
                        pubId: ''
                    },
                    '320x50': {
                        pubId: ''
                    },
                    '120x600': {
                        pubId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/onetag.png')
            },

            /* 'onetag banner static': {
                provider: 'onetag',
                mediaType: 'banner static',
                fields: ['pubId'],
                items: {
                    '300x600': {
                        pubId: ''
                    },
                    '300x250': {
                        pubId: ''
                    },
                    '728x90': {
                        pubId: ''
                    },
                    '160x600': {
                        pubId: ''
                    },
                    '320x50': {
                        pubId: ''
                    },
                    '120x600': {
                        pubId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/onetag.png')
            }, */

            /* 'openx banner static': {
                provider: 'openx',
                mediaType: 'banner static',
                fields: ['delDomain', 'unit'],
                items: {
                    '300x600': {
                        delDomain: '',
                        unit: ''
                    },
                    '300x250': {
                        delDomain: '',
                        unit: ''
                    },
                    '728x90': {
                        delDomain: '',
                        unit: ''
                    },
                    '160x600': {
                        delDomain: '',
                        unit: ''
                    },
                    '320x50': {
                        delDomain: '',
                        unit: ''
                    },
                    '120x600': {
                        delDomain: '',
                        unit: ''
                    },
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/open.png')
            }, */

            'openx banner': {
                provider: 'openx',
                mediaType: 'banner',
                fields: ['delDomain', 'unit'],
                items: {
                    '300x600': {
                        delDomain: '',
                        unit: ''
                    },
                    '300x250': {
                        delDomain: '',
                        unit: ''
                    },
                    '728x90': {
                        delDomain: '',
                        unit: ''
                    },
                    '160x600': {
                        delDomain: '',
                        unit: ''
                    },
                    '320x50': {
                        delDomain: '',
                        unit: ''
                    },
                    '120x600': {
                        delDomain: '',
                        unit: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/open.png')
            },

            /* 'mgid banner static': {
                provider: 'mgid',
                mediaType: 'banner static',
                fields: ['accountId'],
                items: {
                    '300x600': {
                        accountId: ''
                    },
                    '300x250': {
                        accountId: ''
                    },
                    '728x90': {
                        accountId: ''
                    },
                    '160x600': {
                        accountId: ''
                    },
                    '320x50': {
                        accountId: ''
                    },
                    '120x600': {
                        accountId: ''
                    },
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/open.png')
            }, */

            /* 'mgid banner': {
                provider: 'mgid',
                mediaType: 'banner',
                fields: ['accountId'],
                items: {
                    '300x600': {
                        accountId: ''
                    },
                    '300x250': {
                        accountId: ''
                    },
                    '728x90': {
                        accountId: ''
                    },
                    '160x600': {
                        accountId: ''
                    },
                    '320x50': {
                        accountId: ''
                    },
                    '120x600': {
                        accountId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/open.png')
            }, */

            'pubmatic banner static': {
                provider: 'pubmatic',
                mediaType: 'banner static',
                fields: ['publisherId', 'adSlot', 'kadpageurl'],
                items: {
                    '300x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '300x250': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '728x90': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '160x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '320x50': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '120x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/pubmatic.png')
            },

            'pubmatic banner': {
                provider: 'pubmatic',
                mediaType: 'banner',
                fields: ['publisherId', 'adSlot', 'kadpageurl'],
                items: {
                    '300x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '300x250': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '728x90': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '160x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '320x50': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '120x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/pubmatic.png')
            },

            /* 'pubmatic native': {
                provider: 'pubmatic',
                mediaType: 'native',
                fields: ['publisherId', 'adSlot', 'kadpageurl'],
                items: {
                    '300x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '300x250': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '728x90': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '160x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '320x50': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                    '120x600': {
                        publisherId: '',
                        adSlot: '',
                        kadpageurl: ''
                    },
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/pubmatic.png')
            }, */

            'rubicon banner': {
                provider: 'rubicon',
                mediaType: 'banner',
                fields: ['accountId', 'siteId', 'zoneId'],
                items: {
                    '300x600': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                    '300x250': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                    '728x90': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                    '160x600': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                    '320x50': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                    '120x600': {
                        accountId: '',
                        siteId: '',
                        zoneId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/rubicon.png')
            },

            'richaudience banner': {
                provider: 'richaudience',
                mediaType: 'banner',
                fields: ['pid', 'supplyType'],
                items: {
                    '300x600': {
                        pid: '',
                        supplyType: ''
                    },
                    '300x250': {
                        pid: '',
                        supplyType: ''
                    },
                    '728x90': {
                        pid: '',
                        supplyType: ''
                    },
                    '160x600': {
                        pid: '',
                        supplyType: ''
                    },
                    '320x50': {
                        pid: '',
                        supplyType: ''
                    },
                    '120x600': {
                        pid: '',
                        supplyType: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/richaudience.png')
            },

            'smart banner': {
                provider: 'smart',
                mediaType: 'banner',
                fields: ['domain', 'siteId', 'pageId', 'formatId'],
                items: {
                    '300x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '300x250': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '728x90': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '160x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '320x50': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '120x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/smart.png')
            },

            'smartunblockia banner static': {
                provider: 'smartunblockia',
                mediaType: 'banner static',
                fields: ['domain', 'siteId', 'pageId', 'formatId'],
                items: {
                    '300x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '300x250': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '728x90': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '160x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '320x50': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                    '120x600': {
                        domain: '',
                        siteId: '',
                        pageId: '',
                        formatId: ''
                    },
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/smart.png')
            }, 

            /* 'adtelligent banner': {
                provider: 'adtelligent',
                mediaType: 'banner',
                fields: ['aid'],
                items: {
                    '300x600': { aid: ''},
                    '300x250': { aid: ''},
                    '728x90': { aid: ''},
                    '160x600': { aid: ''},
                    '320x50': { aid: ''},
                    '120x600': { aid: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/adtelligent.png')
            },  */

            'smilewanted banner': {
                provider: 'smilewanted',
                mediaType: 'banner',
                fields: ['zoneId'],
                items: {
                    '300x600': { zoneId: ''},
                    '300x250': { zoneId: ''},
                    '728x90': { zoneId: ''},
                    '160x600': { zoneId: ''},
                    '320x50': { zoneId: ''},
                    '120x600': { zoneId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/smilewanted.jpg')
            }, 

            'yahoo banner': {
                provider: 'yahoo',
                mediaType: 'banner',
                fields: ['siteId', 'placementId'],
                items: {
                    '300x600': { siteId: '', placementId: ''},
                    '300x250': { siteId: '', placementId: ''},
                    '728x90': { siteId: '', placementId: ''},
                    '160x600': { siteId: '', placementId: ''},
                    '320x50': { siteId: '', placementId: ''},
                    '120x600': { siteId: '', placementId: ''},
                },
                marginBottom: true,
                emptyContent: true,
                image:require('@assets/images/ssps/yahoossp.png')
            }, 

            'triplelift banner': {
                provider: 'triplelift',
                mediaType: 'banner',
                fields: ['inventoryCode'],
                items: {
                    '300x600': { inventoryCode: ''},
                    '300x250': { inventoryCode: ''},
                    '728x90': { inventoryCode: ''},
                    '160x600': { inventoryCode: ''},
                    '320x50': { inventoryCode: ''},
                    '120x600': { inventoryCode: ''},
                },
                marginBottom: false,
                emptyContent: true,
                image:require('@assets/images/ssps/triplelift.png')
            }
        },
        publishers: [],
        mediaBuyers: [],
        categories: [],
        submitted: false,
        submitStatus: '',
        purgeStatus: '',
        showPrebidCreatedNotification: false,
        domainError: '',
        commentMessage: '',
        isCreatingComment: false,
        commentSubmitted: false,
        comments: [],
        stickyConfigSubmitted: false,
        refreshFrequencySubmitted: false,
        checkingLines: false,
        adstxtMessage: '',
        updatingMytargetId: false,
        updatingChildPublisherNetwork: false
    }

        },

  validations: {
    site: {
      domain: { required },
      publishers: { required },
      mediaBuyer: { required },
      category: { required },
      impressionMultiplier: { required, decimal },
      cpmFloor: { decimal }
    },
    commentMessage: { required },
  },
  computed: {
    prebidGroupsOptions() {
          const obj = {};
          this.prebidGroups.forEach(prebidGroup => {
              obj[prebidGroup.id] = prebidGroup.name
          });

        return obj;
    },
    missingLinesCount() {
      if (!this.site || !this.site.missingLines) {
          return 0
      }

      return this.site.missingLines.split('\r\n').length;
    },
    isEdit() {
      return !!this.$route.params.id
    },
    isAdmin: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    },
    isAccountManager: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "account manager"
    },
    isTrafficker: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "trafficker"
    },
    isMediaBuyer: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
    },
    enableRefresh: {
        get() {
            return !this.site.config.disableRefresh
        },
        set(newValue) {
            this.isVisible = newValue;
        }
    }
  },
 async mounted() {
            await this.fetchPublishers();
            await this.fetchMediaBuyers();
            await this.fetchCategories();
            await this.fetchPrebidGroups();
            if (this.isEdit) {
                await this.fetchComments();
                const response = await axios(SITES_API_URL + this.$route.params.id);
                this.site = response.data;
                this.slides = [...this.site.slides.sort((a, b) => (a.order > b.order) ? 1 : -1)];
                this.site.publishers = response.data.publishers.map(x => ({id: x.id, name: x.name}));
                this.site.prebidAdunits.forEach((adunit, id) => {
                    if (adunit.fields){
                        adunit.fields.forEach(x => {
                            if(adunit.prebidProvider){
                                if (this.prebidAdunits[adunit.prebidProvider.alias + ' ' + adunit.mediaType]){
                                    this.prebidAdunits[adunit.prebidProvider.alias + ' ' + adunit.mediaType].items[adunit.size.name][x.prebidProviderField.name] = x.value;
        
                                    if (x.value) {
                                        this.prebidAdunits[adunit.prebidProvider.alias + ' ' + adunit.mediaType].emptyContent = false;
                                    }
                                }
                            }
                            
                        })
                    }
                });
            }

            if (!this.isEdit && this.isMediaBuyer) {
                this.site.mediaBuyer = JSON.parse(localStorage["auth.currentUser"]);
            }
        },
        methods: {
            slidesListChanged(value) {
              this.slides.forEach((slide, index) => {
                  slide.order = index + 1
              })
            },
            async saveSlides() {
                this.savingSlides = true;
                try {
                    await axios.put(SITES_API_URL + `${this.$route.params.id}/slides`, this.slides);
                } catch (e) {
                    console.log(e);
                } finally {
                    this.savingSlides = false;
                }
            },
            async handleRemoveSlide(item) {
                this.slides = this.slides.filter(slide => slide.id !== item.id)
            },
            async addNewSlide() {
                Vue.swal({
                    title: 'Select a prebid group',
                    input: 'select',
                    inputAttributes: {
                        autocapitalize: 'off',
                    },
                    inputOptions: this.prebidGroupsOptions,
                    showCancelButton: true,
                    confirmButtonText: 'Create',
                    showLoaderOnConfirm: true,
                    allowOutsideClick: () => !Swal.isLoading(),
                }).then((result) => {
                    if (result.value) {
                        const newSlide = {order: this.slides.length + 1, prebidGroup: this.prebidGroups.find(x => x.id === Number(result.value))}
                        this.slides = [...this.slides, newSlide]
                    }
                })
            },
            async addDefaultSlides(){
                this.defaultSlidesNameList.forEach( defaultSlideName => {
                    const newSlide = {order: this.slides.length + 1, prebidGroup: this.prebidGroups.find(x => x.name === defaultSlideName)}
                    this.slides = [...this.slides, newSlide]
                })
            },
            async checkLines() {
                this.adstxtMessage = '';
                const siteId = this.$route.params.id;
                this.checkingLines = true;
                const checkLinesResponse = await axios(CHECK_LINES_URL.replace('[id]', siteId));
                this.site.missingLines = checkLinesResponse.data;
                if (!this.site.missingLines) {
                    this.adstxtMessage = 'NO LINE IS MISSING 👌';
                }
                this.checkingLines = false;
            },
            async fetchSite(){
                const response = await axios(SITES_API_URL + this.$route.params.id);
                this.site = response.data;
            },
            async fetchPublishers() {
                const fetchSitesResponse = await axios(PUBLISHERS_API_URL);
                this.publishers = fetchSitesResponse.data.results.map(item => ({
                    id: item.id,
                    name: item.name
                }));
            },
            async fetchMediaBuyers() {
                const fetchUsersResponse = await axios(USERS_API_URL);
                this.mediaBuyers = fetchUsersResponse.data.results.filter(item => ['admin', 'media buyer', 'account manager'].includes(item.role.name)).map(item => ({
                    id: item.id,
                    name: item.name
                }));
            },
            async fetchCategories() {
                const fetchCategoriesResponse = await axios(DASHBOARD_API_URL + 'iab-category');
                this.categories = fetchCategoriesResponse.data.map( item => ({
                    id: item.id,
                    name: item.name
                }))
            },
            async fetchPrebidGroups() {
                const prebidGroupsResponse = await axios(PREBID_GROUPS_API_URL);
                this.prebidGroups = prebidGroupsResponse.data.results.map( item => ({
                    id: item.id,
                    name: item.name
                }))
            },
            async fetchComments() {
                const siteId = this.$route.params.id;
                const fetchCommentsResponse = await axios(DASHBOARD_API_URL + `sites/${siteId}/comment`);
                this.comments = fetchCommentsResponse.data.map( item => {
                    const date = this.timeSince(new Date(item.updated_at).valueOf());
                    return {id: item.id, message: item.message, name: item.user.name, date}
                })
            },
            async handlePurgeButtonClick(e) {
              this.purgeStatus = 'PURGING';
              try {
                  await axios(CACHE_API_URL + this.$route.params.id);
                  this.purgeStatus = '';
              } catch (e) {
                  console.log(e);
                  this.purgeStatus = '';
              }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.domainError = '';
                // stop here if form is invalid
                this.$v.site.$touch();
                if (this.$v.site.$invalid) {

                    this.submitStatus = 'ERROR'
                } else {
                    // do your submit logic here
                    this.submitStatus = 'PENDING';
                    setTimeout( async () => {
                        try {
                            const data = {
                                ...this.site,
                                publishers: this.site.publishers
                            };
                            if (!this.isEdit) {
                                delete data.config;
                            }
                            const action = this.isEdit ? 'put' : 'post';
                            const url = !this.isEdit ? SITES_API_URL : SITES_API_URL + this.$route.params.id;
                            const response = await axios[action](url, data);
                            if (!response.data.error){
                                this.submitStatus = 'OK';
                                this.$router.push('/admin/sites')
                            }else{
                                this.submitStatus = 'ERROR';
                                this.domainError = response.data.error.toString()
                            }
                        } catch (e) {
                            this.submitStatus = 'ERROR'
                        }
                    }, 500)
                }
            },
            async handleUpdatePrebidValue(size, key, value, provider, mediaType) {
                const site = this.$route.params.id;
                try {
                    await axios.put(PREBID_ADUNITS_API_URL, {
                        size,
                        key,
                        value,
                        provider,
                        site,
                        mediaType
                    });
                    this.showPrebidCreatedNotification = true;

                    /* set empty content */
                    this.prebidAdunits[provider + ' ' + mediaType].emptyContent = true;
                    Object.values(this.prebidAdunits[provider + ' ' + mediaType].items).forEach(id => {
                        if(id[this.prebidAdunits[provider + ' ' + mediaType].fields[0]]) {
                           this.prebidAdunits[provider + ' ' + mediaType].emptyContent = false;
                        }
                    });

                    setTimeout(() => {
                        this.showPrebidCreatedNotification = false;
                    }, 1000)
                } catch (e) {
                }
            },
            async handleCrearePrebidCommend(commentMessage) {
                const siteId = this.$route.params.id;
                const userId = JSON.parse(localStorage["auth.currentUser"]).id;
                this.commentSubmitted = true;

                if(this.$v.commentMessage.$invalid){


                }else{
                    try {
                        await axios.post(DASHBOARD_API_URL + `sites/${siteId}/comment`, {commentMessage, userId});
                        this.isCreatingComment = false;
                        this.commentSubmitted = false;
                        this.$refs['modal-comment'].hide();
                        this.commentMessage = '';
                        this.fetchComments()

                    } catch (e) {
                    }

                }
            },
            async toggleWhitelistedConfig(configId, key, value, id) {
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `config/sites`,
                        data: {
                            configId: this.site.config.id,
                            key: 'isWhitelisted',
                            value: this.site.config.isWhitelisted
                        }
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleActiveConfig() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-is-active`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleOcmConfig() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-is-ocm`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleYieldbirdConfig() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-is-yieldbird`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleAdponeGamActivated() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-adpone-gam-activated`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleGoogleBlocked() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-google-blocked`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async toggleBackupsEnabled() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-backups-enabled`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async deleteComment(commentId) {
                await axios.delete(DASHBOARD_API_URL + `comments/${commentId}`);
                this.fetchComments();
                this.$refs['modal-comment'].hide();

            },
            handleCpmFloorChange() {
                if(this.site.cpmFloor){
                    this.site.impressionMultiplier = 1;
                }
            },
            handleImpressionMultiplierChange() {
                if(this.site.impressionMultiplier != 1) {
                    this.site.cpmFloor = null;
                }
            },
            async updateStickyConfig() {
                const {id} = this.$route.params;
                this.stickyConfigSubmitted = true;
                try {
                    await axios.put(DASHBOARD_API_URL + `sites/${id}/sticky-config`, {showStickyAt: this.site.config.showStickyAt});
                    this.stickyConfigSubmitted = false;
                } catch (e) {

                }

            },
            async updateMytargetId() {
                const {id} = this.$route.params;
                this.updatingMytargetId = true;
                try {
                    await axios.put(DASHBOARD_API_URL + `sites/${id}/mytarget-id`, {mytargetId: this.site.mytargetId});
                    this.updatingMytargetId = false;
                } catch (e) {
                }
            },
            async updatePubmaticSiteId() {
                const { id } = this.$route.params;
                this.updatingPubmaticSiteId = true;
                try {
                    await axios.put(DASHBOARD_API_URL + `sites/${id}/pubmatic-site-id`, {pubmaticSiteId: this.site.pubmaticSiteId});
                    this.updatingPubmaticSiteId = false;
                } catch (e) {
                }
            },
            async updateChildPublisherNetwork() {
                const {id} = this.$route.params;
                this.updatingChildPublisherNetwork = true;
                try {
                    await axios.put(DASHBOARD_API_URL + `sites/${id}/child-publisher-network`, {childPublisherNetwork: this.site.childPublisherNetwork});
                    this.updatingChildPublisherNetwork = false;
                } catch (e) {
                }
            },
            async toggleRefresh() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-refresh`
                    });
                } catch (e) {
                    console.log(e)
                }
                await this.fetchSite();
            },
            async toggleRefreshOnlySideAds() {
                const {id} = this.$route.params;
                try {
                    await axios({
                        method: 'patch',
                        url: DASHBOARD_API_URL + `sites/${id}/toggle-refresh-only-side-ads`
                    });
                } catch (e) {
                    console.log(e)
                }
            },
            async updateRefreshFrequency() {
                const {id} = this.$route.params;
                this.refreshFrequencySubmitted = true;
                const data = {
                    refreshFrequency: this.site.config.refreshFrequency
                };
                try {
                    await axios.put(DASHBOARD_API_URL + `sites/${id}/refresh-frequency`, data);
                    this.refreshFrequencySubmitted = false;
                } catch (e) {

                }
            },
            goBack(e) {
             e.preventDefault();
             this.$router.go(-1);
            },

            prettyDate: function (date) {
            // `this` points to the vm instance
            const d = new Date(date);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return yyyy + '-' + mm + '-' + dd;
            },
            timeSince(date) {
                var seconds = Math.floor((new Date() - date) / 1000);
                var interval = seconds / 31536000;
                if (interval > 1) {
                    return Math.floor(interval) + " years";
                }
                interval = seconds / 2592000;
                if (interval > 1) {
                    return Math.floor(interval) + " months";
                }
                interval = seconds / 86400;
                if (interval > 1) {
                    return Math.floor(interval) + " days";
                }
                interval = seconds / 3600;
                if (interval > 1) {
                    return Math.floor(interval) + " hours";
                }
                interval = seconds / 60;
                if (interval > 1) {
                    return Math.floor(interval) + " minutes";
                }
                return Math.floor(seconds) + " seconds";
                }
            },

    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

            <div class="site-form">
                <b-tabs justified pills class="navtab-bg">
                    <b-tab class="card-box" title="Basic Information" active>
                        <b-alert show dismissible variant="danger" v-if="domainError">{{domainError}}</b-alert>
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="domain">
                                            Domain
                                            <span v-if="!this.isEdit" class="text-danger">*</span>
                                        </label>
                                        <input
                                                placeholder="Domain"
                                                v-model="site.domain"
                                                type="text"
                                                class="form-control disabled-text"
                                                :class="{ 'is-invalid': submitted && ($v.site.domain.$error) }"
                                                :disabled="isEdit"
                                        />
                                        <div
                                                v-if="submitted && !$v.site.domain.required"
                                                class="invalid-feedback"
                                        >
                                            This value is required.
                                        </div>
                                    </div>
                                </div>
                                <!-- end col -->

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            Select publisher
                                            <span class="text-danger">*</span>
                                        </label>
                                        <multiselect
                                                placeholder="Publisher"
                                                v-model="site.publishers[0]"
                                                :options="publishers"
                                                track-by="id"
                                                label="name"
                                                :class="{ 'invalid-input': submitted && $v.site.publishers.$error }"
                                        >
                                        </multiselect>
                                        <div
                                                v-if="submitted && !$v.site.publishers.required"
                                                class="invalid"
                                        >
                                            This value is required.
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            {{ isMediaBuyer ? 'Media buyer' : 'Select a media buyer'}}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <multiselect
                                                placeholder="Media buyer"
                                                v-model="site.mediaBuyer"
                                                :options="mediaBuyers"
                                                track-by="id"
                                                label="name"
                                                :class="{ 'invalid-input': submitted && $v.site.mediaBuyer.$error }"
                                                :disabled="isMediaBuyer"
                                        >
                                        </multiselect>
                                        <div
                                                v-if="submitted && !$v.site.mediaBuyer.required"
                                                class="invalid"
                                        >
                                            This value is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            Select category
                                            <span class="text-danger">*</span>
                                        </label>
                                        <multiselect
                                                placeholder="Category"
                                                v-model="site.category"
                                                :options="categories"
                                                track-by="id"
                                                label="name"
                                                :class="{ 'invalid-input': submitted && $v.site.category.$error }"
                                        >
                                        </multiselect>
                                        <div
                                                v-if="submitted && !$v.site.category.required"
                                                class="invalid"
                                        >
                                            This value is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            Select country
                                        </label>
                                        <country-select
                                            v-model="site.country"
                                            :country="site.country"
                                            id="country"
                                            :countryName="true"
                                            placeholder=" "
                                            className="custom-select select"/>

                                    </div>
                                </div>
                                <div class="col-md-6" v-if="isAdmin">
                                    <div class="form-group">
                                        <label>Impression multiplier</label>
                                        <span class="text-danger">*</span>
                                        <input
                                                v-model="site.impressionMultiplier"
                                                type="text"
                                                class="form-control"
                                                :class="{ 'is-invalid': submitted && ( $v.site.impressionMultiplier.$error ) }"
                                                @change="handleImpressionMultiplierChange"
                                        />
                                        <div
                                                v-if="submitted && !$v.site.impressionMultiplier.required"
                                                class="invalid"
                                        >
                                            This value is required.
                                        </div>
                                        <div
                                                v-if="submitted && !$v.site.impressionMultiplier.decimal"
                                                class="invalid"
                                        >
                                            This value must be a number.
                                        </div>

                                        <p
                                                v-if="isEdit && site.impressionMultiplierLastUpdate"
                                                class="mt-1 text-muted"
                                        >
                                            ( Last update: {{prettyDate(site.impressionMultiplierLastUpdate) }} )</p>

                                    </div>
                                </div>
                                <div class="col-md-6"  v-if="isAdmin">
                                    <div class="form-group">
                                        <label for="domain">
                                            Cpm Floor
                                        </label>
                                        <input
                                                placeholder="Cpm floor"
                                                v-model="site.cpmFloor"
                                                type="text"
                                                class="form-control"
                                                :class="{ 'is-invalid': submitted && ($v.site.cpmFloor.$error) }"
                                                @change="handleCpmFloorChange"
                                        />
                                        <div
                                                v-if="submitted && !$v.site.cpmFloor.decimal"
                                                class="invalid-feedback"
                                        >
                                            This value must be a number.
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12 offset-12">
                                    <div class="form-group mb-0">
                                        <div>
                                            <button
                                                    v-if="submitStatus !== 'PENDING'"
                                                    type="submit"
                                                    class="btn btn-primary"
                                            >Submit
                                            </button>
                                            <b-button variant="primary" v-else disabled>
                                                <b-spinner small></b-spinner>
                                                <span>Submitting...</span>
                                            </b-button>
                                            <!--<button @click="goBack" class="btn btn-secondary m-l-5 ml-1">Back</button>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </b-tab>
                    <b-tab class="card-box" title="Advanced" v-if="(isEdit) && (isAdmin || isAccountManager || isTrafficker)">
                        <div v-if="isEdit" class="row">
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="card-box">
                                        <h4 class="header-title">Whitelist site</h4>
                                        <p class="sub-header">
                                            Marca como whitelisted el site cuando eyeo haya actualizado la lista de filtros
                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.isWhitelisted"
                                                    id="isWhitelisted"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleWhitelistedConfig"
                                                    :disabled="site.config.isWhitelisted && site.isActive"
                                            />
                                            <label class="custom-control-label" for="isWhitelisted" > WhiteListed </label>
                                        </div>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="card-box">
                                        <h4 class="header-title">Activate site</h4>
                                        <p class="sub-header">
                                            Marca como whitelisted el site cuando eyeo haya actualizado la lista de filtros
                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.isActive"
                                                    id="isActive"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleActiveConfig"
                                                    :disabled="!site.config.isWhitelisted && !site.isActive"
                                            />
                                            <label class="custom-control-label" for="isActive" > Active </label>
                                        </div>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="card-box">
                                        <h4 class="header-title">Upload Config to S3</h4>
                                        <p class="sub-header">
                                            Sube la configuración a AWS S3
                                        </p>

                                        <button
                                                v-if="purgeStatus !== 'PURGING'"
                                                type="submit"
                                                class="btn btn-primary"
                                                @click="handlePurgeButtonClick"
                                        >Subir
                                        </button>
                                        <b-button variant="primary" v-else disabled>
                                            <b-spinner small></b-spinner>
                                            <span>Subiendo...</span>
                                        </b-button>

                                    </div>
                                </div>

                                <!-- <div class="card-box col-12">
                                    <h4 class="header-title">Mytarget ID (App ID)</h4>
                                    <p class="sub-header">
                                        Fill the input below with the App ID from Mytarget Dashboard
                                    </p>

                                    <p class="">
                                        <input
                                                type="text"
                                                class="form-control d-inline-block col-3"
                                                v-model="site.mytargetId"
                                        >
                                    </p>

                                    <b-button variant="primary" class="d-inline-block" @click="updateMytargetId" v-if="!updatingMytargetId" size="sm">Update</b-button>
                                    <b-button variant="primary" disabled v-else size="sm">
                                        <b-spinner small></b-spinner>
                                        <span>Updating...</span>
                                    </b-button>
                                </div> -->

                                <div class="card-box col-12">
                                    <h4 class="header-title">Pubmatic site ID</h4>
                                    <p class="sub-header">
                                        Fill the input below with the Site ID from Pubmatic Dashboard
                                    </p>

                                    <p class="">
                                        <input
                                                type="text"
                                                class="form-control d-inline-block col-3"
                                                v-model="site.pubmaticSiteId"
                                        >
                                    </p>

                                    <b-button variant="primary" class="d-inline-block" @click="updatePubmaticSiteId" v-if="!updatingMytargetId" size="sm">Update</b-button>
                                    <b-button variant="primary" disabled v-else size="sm">
                                        <b-spinner small></b-spinner>
                                        <span>Updating...</span>
                                    </b-button>
                                </div>

                                <div class="card-box col-12">
                                    <h4 class="header-title">Child Network ID</h4>
                                    <p class="sub-header">
                                        Fill the input below with the Child Network ID
                                    </p>

                                    <p class="">
                                        <input
                                                type="text"
                                                class="form-control d-inline-block col-3"
                                                v-model="site.childPublisherNetwork"
                                        >
                                    </p>

                                    <b-button variant="primary" class="d-inline-block" @click="updateChildPublisherNetwork" v-if="!updatingChildPublisherNetwork" size="sm">Update</b-button>
                                    <b-button variant="primary" disabled v-else size="sm">
                                        <b-spinner small></b-spinner>
                                        <span>Updating...</span>
                                    </b-button>

                                </div>


                            </div>

                            <div class="col-md-6">
                                <!-- <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">OCM</h4>
                                        <p class="sub-header">
                                            Márcalo cuando es un site de OCM

                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.isOcm"
                                                    id="isOcm"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleOcmConfig"
                                            />
                                            <label class="custom-control-label" for="isOcm" > OCM site </label>
                                        </div>

                                    </div>
                                </div> -->

                                <!-- <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">YIELDBIRD</h4>
                                        <p class="sub-header">
                                            Márcalo cuando es un site de YIELDBIRD

                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.isYieldbird"
                                                    id="isYieldbird"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleYieldbirdConfig"
                                            />
                                            <label class="custom-control-label" for="isYieldbird" > YIELDBIRD site </label>
                                        </div>

                                    </div>
                                </div> -->

                                <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">Google Blocked</h4>
                                        <p class="sub-header">
                                            Márcalo cuando  esta google blocked

                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.googleBlocked"
                                                    id="isGoogleBlocked"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleGoogleBlocked"
                                            />
                                            <label class="custom-control-label" for="isGoogleBlocked" > Google blocked </label>
                                        </div>

                                    </div>
                                </div>

                                <!-- <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">Adpone GAM</h4>
                                        <p class="sub-header">
                                            Márcalo cuando Adpone GAM esta activado

                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.adponeGamActivated"
                                                    id="isAdponGamActivated"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleAdponeGamActivated"
                                            />
                                            <label class="custom-control-label" for="isAdponGamActivated" > Adpone GAM Activated </label>
                                        </div>

                                    </div>
                                </div> -->

                                <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">Backup Ads</h4>
                                        <p class="sub-header">
                                            Márcalo cuando Backup Ads esta enabled

                                        </p>

                                        <div class="custom-control custom-switch" v-if="site && site.config">
                                            <input
                                                    v-model="site.config.backupsEnabled"
                                                    id="isBackupsEnabled"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleBackupsEnabled"
                                            />
                                            <label class="custom-control-label" for="isBackupsEnabled" > Backup Ads Enabled </label>
                                        </div>

                                    </div>
                                </div>

                                <div class="row col-12">
                                    <div class="card-box col-12">
                                        <h4 class="header-title">Sticky Ads</h4>
                                        <p class="sub-header">
                                            Customize the display of sticky ad, make it appear after a certain height.
                                        </p>
                                        <p class="">
                                            Show sticky ads after
                                            <input
                                                    type="text"
                                                    class="form-control d-inline-block col-3"
                                                    v-model="site.config.showStickyAt"
                                            >
                                            px
                                        </p>

                                        <b-button variant="primary" class="d-inline-block" @click="updateStickyConfig" v-if="!stickyConfigSubmitted" size="sm">Update</b-button>
                                        <b-button variant="primary" v-else disabled size="sm">
                                            <b-spinner small></b-spinner>
                                            <span>Updating...</span>
                                        </b-button>

                                    </div>

                                    <div class="card-box col-12">
                                        <h4 class="header-title">Ad Refresh</h4>
                                        <p class="sub-header">
                                            Customize the refresh frequency or deactivate the ad refresh when you don't want it
                                        </p>
                                        <div class="custom-control custom-switch mb-2" v-if="site && site.config">
                                            <input
                                                    v-model="enableRefresh"
                                                    id="isAdrefreshEnabled"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleRefresh"
                                            />
                                            <label class="custom-control-label" for="isAdrefreshEnabled" > Enabled </label>
                                        </div>
                                        <div class="custom-control custom-switch" v-if="site && site.config && enableRefresh">
                                            <input
                                                    v-model="site.config.refreshOnlySideAds"
                                                    id="onlySideAdsEnabled"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    @change="toggleRefreshOnlySideAds"
                                            />
                                            <label class="custom-control-label" for="onlySideAdsEnabled" > Only side ads enabled </label>
                                        </div>
                                        <br>
                                        <p class="">
                                            Refresh Frequency: &nbsp
                                            <input
                                                    type="text"
                                                    class="form-control d-inline-block col-2 mr-4"
                                                    v-model="site.config.refreshFrequency"
                                                    :disabled="site.config.disableRefresh"
                                                    :class="{ 'disabled-text': site.config.disableRefresh }"
                                            >
                                            <b-button variant="primary" class="d-inline-block" size="sm" @click="updateRefreshFrequency" v-if="!refreshFrequencySubmitted">Update</b-button>
                                            <b-button variant="primary" v-else disabled size="sm">
                                                <b-spinner small></b-spinner>
                                                <span>Updating...</span>
                                            </b-button>
                                        </p>
                                    </div>

                                </div>

                            </div>


                        </div>


                    </b-tab>
                    <b-tab class=" pl-lg-5 pr-lg-5" title="Prebid" v-if="(isEdit) && (isAdmin || isAccountManager || isTrafficker)">
                        <div v-if="isEdit">
                            <div>
                                    <div role="tablist" class="mt-4 mb-4">
                                        <b-card v-if="comments.length > 0" no-body class="mb-4 view-comments">
                                            <a v-b-toggle.accordion-x class="text-dark">
                                                <b-card-header header-tag="header" role="tab" class="provider-title ">
                                                <h5 class="m-0">
                                                    <i class="mdi mdi-star mr-2"/>
                                                    VIEW COMMENTS
                                                </h5>
                                                </b-card-header>
                                            </a>
                                            <b-collapse id="accordion-x" accordion="my-accordion" role="tabpanel">
                                            <b-card-body class="info-body">
                                                <div v-for="(comment, index) in comments" :key="comment.id" class="comment">
                                                    <div class="mb-2 row">
                                                        <div class="d-flex align-items-center ml-2 col-lg-2 col-xs-12">
                                                            <i class="fe-message-square mr-2"></i>
                                                            <div class="">
                                                                <p class="text-dark h5 mb-0">{{comment.name}}</p>
                                                                <p class="mb-0 text-dark"> <small>{{comment.date}} ago</small> </p>
                                                            </div>
                                                        </div>

                                                        <div class="ml-4 mt-2 col-lg-9 col-xs-12 ">{{comment.message}}</div>

                                                        <i class="fe-x" v-b-modal="'modal-' + index"></i>
                                                        <b-modal
                                                        :id="'modal-' + index"
                                                        centered
                                                        size="sm"
                                                        title="Are you sure?"
                                                        title-class="font-18"
                                                        hide-footer
                                                        >
                                                          <b-button variant="danger" @click="deleteComment(comment.id)" class="mr-2">Delete Comment</b-button>
                                                          <b-button variant="light" @click="$bvModal.hide(`modal-${index}`)">Never mind</b-button>

                                                        </b-modal>

                                                    </div>

                                                </div>
                                            </b-card-body>
                                            </b-collapse>
                                        </b-card>

                                        <form @submit.prevent="handleSubmit">
                                            <b-card v-for="(provider, index) in Object.keys(prebidAdunits)" :key="provider" no-body class="mb-2 provider-unit" :class="{ 'provider-end':prebidAdunits[provider].marginBottom}">
                                                <a v-b-toggle="'accordion-' + index" class="text-dark">
                                                    <b-card-header
                                                            header-tag="header"
                                                            role="tab"
                                                            class="provider-title not-empty-content"
                                                            :class="{'empty-content' : prebidAdunits[provider].emptyContent}">
                                                        <img class="provider-logo" :src="prebidAdunits[provider].image" ></img>
                                                        <h5
                                                            class="m-0  text-uppercase "
                                                            >
                                                            {{ prebidAdunits[provider].tagName ? prebidAdunits[provider].tagName : prebidAdunits[provider].provider }} <span class="text-muted font-weight-normal">({{prebidAdunits[provider].providerSubtitle ? prebidAdunits[provider].providerSubtitle : prebidAdunits[provider].mediaType}})</span>
                                                        </h5>
                                                    </b-card-header>
                                                </a>

                                                <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                                                <b-card-body>
                                                    <table class="table table-bordered mt-3 text-center">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th v-for="field in prebidAdunits[provider].fields" :key="field"> {{ field }}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(item, index) in Object.keys(prebidAdunits[provider].items)" :key="index">
                                                        <th scope="row"> {{ item }}</th>
                                                        <td v-for="field in prebidAdunits[provider].fields" :key="field">
                                                            <span v-for="(value, index) in Object.keys(prebidAdunits[provider].items[item])" :key="index">
                                                                <input
                                                                    v-if="value === field"
                                                                    v-model="prebidAdunits[provider].items[item][value]"
                                                                    type="text"
                                                                    class="form-control"
                                                                    @change="handleUpdatePrebidValue(item, value, prebidAdunits[provider].items[item][value], prebidAdunits[provider].provider, prebidAdunits[provider].mediaType)"
                                                                />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                </b-card-body>
                                                </b-collapse>

                                            </b-card>

                                        </form>
                                    </div>

                                     <div class="create-comment">

                                        <b-button v-b-modal.modal-comment>
                                            <i class="mdi mdi-file-plus"></i>
                                        </b-button>

                                        <b-modal
                                            id="modal-comment"
                                            ref="modal-comment"
                                            title="New comment"
                                            title-class="font-18"
                                            body-class="p-4"
                                            centered
                                            hide-footer
                                        >
                                            <form>
                                                <div class="form-group">

                                                    <textarea
                                                        class="form-control mb-2 "
                                                        v-model="commentMessage"
                                                        placeholder="Leave a comment here ..."
                                                        @input="creatingCommentError=''"
                                                        :class="{ 'is-invalid': commentSubmitted && !$v.commentMessage.required }"
                                                        ></textarea>
                                                    <p
                                                            v-if="commentSubmitted && !$v.commentMessage.required"
                                                            class="invalid"
                                                    >
                                                        This value is required.
                                                    </p>
                                                    <b-button
                                                        variant="primary"
                                                        class="mr-2"
                                                        v-if="!isCreatingComment"
                                                        @click="handleCrearePrebidCommend(commentMessage)"
                                                    >Submit</b-button>
                                                    <b-button
                                                        variant="primary"
                                                        disabled
                                                        class="mr-2"
                                                        v-if="isCreatingComment"
                                                    >
                                                        <b-spinner small type="grow"></b-spinner
                                                        >&nbsp;&nbsp;Submitting...
                                                    </b-button>
                                                    <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-comment')">Close</b-button>
                                                    <b-button variant="success" @click="commentMessage=''">Clear</b-button>
                                                </div>
                                            </form>

                                        </b-modal>
                                    </div>


                            </div>
                        </div>
                    </b-tab>
                    <b-tab class="card-box" title="Ads.txt" v-if="isEdit">
                        <div v-if="isEdit">
                            <label>
                                Missing Lines: <span> {{ missingLinesCount }} </span>
                            </label>
                            <p v-if="site.lastAdstxtCheck"> Check Date: {{site.lastAdstxtCheck ? site.lastAdstxtCheck.slice(0, 10) : ''}}</p>
                            <textarea
                                    v-model="site.missingLines"
                                    class="form-control"
                                    :rows="missingLinesCount"
                                    disabled
                            ></textarea>

                            <b-button
                                    variant="primary"
                                    class="mt-2"
                                    @click="checkLines"
                                    v-if="!checkingLines"
                            >  <i class="mdi mdi-refresh"></i> Check
                            </b-button>
                            <b-button variant="primary" v-else class="mt-2" disabled>
                                <b-spinner small></b-spinner>
                                <span>Checking...</span>
                            </b-button>

                            <span class="ml-4 text-primary">{{adstxtMessage}}</span>

                        </div>
                    </b-tab>
                    <b-tab class="card-box" title="Slides" v-if="isEdit && isAdmin">
                        <div v-if="isEdit">
                            <div class="card-box">

                                <div class="row">
                                    <div class="col-md-6">
                                        <h4 class="header-title">Slides</h4>
                                        <p
                                                class="sub-header"
                                        ></p>

                                        <VueNestable v-model="slides" class="dd-handle" @input="slidesListChanged">
                                            <div slot="placeholder">
                                                <b>This list is empty</b>
                                            </div>

                                            <!-- Handler -->
                                            <VueNestableHandle slot-scope="{ item }" :item="item">{{ item.prebidGroup.name }}
                                                <i @click.prevent="handleRemoveSlide(item)" class="fe-x noti-icon erase-slide-button"></i>
                                            </VueNestableHandle>
                                            
                                        </VueNestable>
                                    </div>

                                    <!-- end col -->

                                    <!-- end col -->
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="new-slide-button">
                                            <b-button
                                        
                                            variant="outline-dark"
                                                    class="mr-2 mt-3"
                                                    @click="addNewSlide()"
                                            > <i class="fe-plus"></i>
                                            </b-button>
                                        </div>

                                        <div class="new-slide-button">
                                            <b-button
                                                    class="mr-2"
                                                    @click="addDefaultSlides()"
                                            > Quick add  <i class="fe-thumbs-up"></i>
                                            </b-button>
                                        </div>

                                    </div>

                                </div>
                                <!-- end row -->
                            </div>
                            <b-button
                                    v-if="!savingSlides"
                                    variant="primary"
                                    class="mr-2"
                                    @click="saveSlides()"
                            >Save</b-button>
                            <b-button
                                    v-else
                                    variant="primary"
                                    class="mr-2"
                            >Saving</b-button>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>


        <div class="site-prebid-updated-notification" v-if="showPrebidCreatedNotification">
            <b-alert show variant="primary"> Updated successfully! </b-alert>
        </div>

    </Layout>

</template>

<style lang="scss">
    .site-form {
        background-color: #fff;
        padding: 1rem;
        margin-bottom: 24px;
        border-radius: 0.25rem;

    }
    .site-prebid-updated-notification {
        position: fixed;
        right: 100px;
        bottom: 30px;
        width: 200px;
        z-index: 2;
    }

    .invalid{
        color:#f1556c;
        font-size:0.75rem;
    }
    .invalid-input .multiselect__tags{
        border:#f1556c 1px solid !important;
    }
    .disabled-text.form-control:disabled{
        color: #999da0;
        background-color: #f2f2f2;
    }

    .view-comments{
        .provider-title{
            background-color: white;
            border: 1px solid #ced4da;
            // border-bottom: 2px solid rgba(#6658dd, 0.8);
            // border-right: 2px solid rgba(#6658dd, 0.8);
            h5{
                font-weight: 500;

                i{
                    color: #ffc107;
                    font-size: 1.4rem;
                }
            }

        }
        .info-body{

            .comment{
                border-bottom: rgba(gray, 0.3) 1px solid;
                margin-bottom: 10px;
                position: relative;
            }
        }
        i.fe-x{
            position: absolute;
            right: 0.5rem;
            top: 0.5rem;
            cursor: pointer;
        }
        i.mdi{
            font-size: 1rem;
        }
    }

    .provider-title{
        background: #f7f7f7;
        border-radius: 5px !important;
        cursor:pointer;
        display: flex;
        .provider-logo{
            width: 15px;
            height:15px;
            margin-right: 1rem;
            align-items: flex-end;
        }
        h5{
            font-size: 0.8rem;
            font-weight: 400;
            font: optional;

        }
    }

    .provider-unit{
        .empty-content{
            border: 1px solid #ced4da !important;
            background: white !important;
            h5{
                font-weight: 400 !important;
                color:gray !important;
            }
        }
        .not-empty-content{
            border: 1px solid #ced4da;
            background: rgba(gray, 0.08);
            // background: black;

            h5{
                font-weight: 600;
                // color: white;
            }
        }
    }

    .provider-end::after {
        content: '';
        display: block;
        height: 1px;
        border-top: rgba(gray,0.5) dashed 1px;
        margin: 20px 5px 10px;
    }

    .create-comment{
        position: fixed;
        right: 40px;
        bottom: 40px;
        z-index: 2;
        button{
            width:55px;
            height: 55px;
            border-radius: 50px;
            background-color: white;
            border: 1px solid rgba(gray, 0.4);
            i{
                font-size: 1.4rem;
                color:#6658dd;
            }
            &:hover{
                background-color: white;
                border: 1px solid rgba(gray, 0.4);
            }
        }
    }

    .multiselect--disabled {
        background: none;
    }
    .multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select {
        background: none;
    }
    .erase-slide-button {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .new-slide-button {
        margin-left: 20px;
        margin-top: 10px;

        button {
            width: 100%;
        }
    }
</style>
